import React from "react";

const CheckboxGroup = ({
  segMeds,
  label,
  onChange,
}) => {
  return (
    <div className="rounded-lg border p-2 bg-white  text-base">
      <p className="font-semibold mb-1">{label}</p>

      <div className="grid grid-cols-2 gap-2">
        {Object.keys(segMeds).map((med) => (
          <label
            key={med}
            className="flex items-center gap-2 cursor-pointer"
          >
            <input
              type="checkbox"
              checked={segMeds[med] === true}
              onChange={(e) =>
                onChange(med, e.target.checked ? true : null)
              }
              className="accent-blue-600 border-2 border-gray-700"
            />
            <span>{med}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default CheckboxGroup;
